<template>
  <section>
    <el-col :span="22" class="showDataDetail" style="padding:10px;" v-if="assetDetail">
      <div class="tip">* 基本资料</div>
      <ul>
        <li class="full">
          <label>资产编号:</label>
          <span>{{assetDetail.number}}</span>
        </li>
        <li class="full">
          <label>资产名称:</label>
          <span>{{assetDetail.name}}</span>
        </li>
        <li class="full">
          <label>分类:</label>
          <span>{{ getClassify(assetDetail) }}</span>
        </li>
        <li>
          <label>资产属性:</label>
          <span>{{ assetDetail.attribute.name }}</span>
        </li>
        <li class="full">
          <label>购置金额:</label>
          <span>{{assetDetail.price}} 元</span>
        </li>
        <li>
          <label>购置时间:</label>
          <span>{{assetDetail.purchaseTime}}</span>
        </li>
        <li>
          <label>入库时间:</label>
          <span>{{assetDetail.storageTime}}</span>
        </li>
        <li>
          <label>入账时间:</label>
          <span>{{assetDetail.rzTime}}</span>
        </li>
        <li>
          <label>当前状态:</label>
          <span v-html="getStatus(assetDetail.status)"></span>
        </li>

        <li>
          <label>累计折旧:</label>
          <span>{{ assetDetail.ljzj }}</span>
        </li>
        <li>
          <label>当前净值:</label>
          <span>{{ assetDetail.jz }}</span>
        </li>
        <li>
          <label>残值:</label>
          <span>{{ assetDetail.cz }}</span>
        </li>
        <li>
          <label>折旧年限:</label>
          <span>{{ assetDetail.zjnx }}</span>
        </li>
        <li v-if="assetDetail.panStatus && assetDetail.panStatus!='-1'">
          <label>盘点情况:</label>
          <span>
            <strong v-if="assetDetail.panStatus==1" style="color:green">盘亏</strong>
            <strong v-else-if="assetDetail.panStatus==0" style="color:red">盘盈</strong>
            <strong v-else-if="assetDetail.panStatus==2">正常</strong>
            <strong v-else>未登记</strong>
          </span>
        </li>
      </ul>

      <div class="tip">* 规格型号属性</div>
      <ul>
        <li class="full">
          <label>规格型号:</label>
          <span>{{assetDetail.spec}}</span>
        </li>
        <li class="full">
          <label>厂商:</label>
          <span>{{assetDetail.manufacturer}}</span>
        </li>
        <li class="full">
          <label>证书编号:</label>
          <span>{{assetDetail.certificateNum}}</span>
        </li>
        <li>
          <label>出厂日期:</label>
          <span>{{assetDetail.ccTime}}</span>
        </li>
        <li>
          <label>截止保修期:</label>
          <span>{{assetDetail.bxTime}}</span>
        </li>
        <li class="full">
          <label>供应商:</label>
          <span>{{assetDetail.supplier?assetDetail.supplier.name:''}}</span>
        </li>
      </ul>

      <div class="tip">* 使用存放</div>
      <ul>
        <li class="full">
          <label>所属部门:</label>
          <span>{{assetDetail.assetDept?assetDetail.assetDept.name:''}}</span>
        </li>
        <li class="full">
          <label>存放地点:</label>
          <span>{{assetDetail.usePlace}}</span>
        </li>
        <li>
          <label>使用人:</label>
          <span>{{assetDetail.user ? assetDetail.user.name : ""}}</span>
        </li>
        <li>
          <label>责任人:</label>
          <span>{{assetDetail.zrUser ? assetDetail.zrUser.name : ""}}</span>
        </li>
        <li>
          <label>入库确认(财务):</label>
          <span>{{assetDetail.cwUser ? assetDetail.cwUser.name : ""}}</span>
        </li>
        <li class="remark full">
          <label>备注:</label>
          <span>{{assetDetail.remark}}</span>
        </li>
      </ul>
    </el-col>
  </section>
</template>


<script>
  import {
    mapState
  } from "vuex";

  export default {
    components: {},
    computed: {
      ...mapState({})
    },
    data() {
      return {
        attributeArr: ['自制', '采购', '租赁', '出租', '其他'],
        dataList: [],
        assetId: '',
        assetDetail: {},
      }
    },
    created() {},
    mounted() {
      if (this.$route.params.id) {
        this.assetId = this.$route.params.id
        ajax.get('/asset/info/' + this.assetId, '', (res) => {
          this.assetDetail = res.vo
        })
      }
    },
    methods: {
      getStatus(status) {
        let statusName = ["闲置中", "使用中", "维修中", "正常报废", "非正常报废", "损毁", "出售", "其他", "盘盈", "盘亏"]
        return statusName[status]
      },
      // 组装分类
      getClassify(data) {
        let _str = ""
        if (data.mClassify) {
          _str += data.mClassify.name + " / "
        }
        if (data.dClassify) {
          _str += data.dClassify.name + " / "
        }
        if (data.parentClassify) {
          _str += data.parentClassify.name + " / "
        }
        if (data.classify) {
          _str += data.classify.name
        }
        return _str
      },
      handleClick() {},
    },
    watch: {}
  }
</script>


// WEBPACK FOOTER //
// src/page/m/assetDetail.vue